import React, { Component, PropTypes } from 'react';
import { Router, browserHistory } from 'react-router';
import {Link} from 'react-router';
import Persistence from '../Persistence/Persistence'
import RecommendationComponent from './RecommendationComponent'
import QuestionComponent from './QuestionComponent'
import QuestionComponentDelegate from './QuestionComponent'
import LearnMoreComponent from './LearnMoreComponent'
import TextComponent from './TextComponent'
import TextParser from "../models/TextParser"
import DisclaimerComponent from "./DisclaimerComponent"
import RecommendationAlgorithm from '../models/RecommendationAlgorithm'
import BrowserNotSupportedComponent from "./BrowserNotSupportedComponent"
import Answer from '../models/Answer'
import Question from '../models/Question'
import Recommendation from '../models/Recommendation'
import NavBar from './NavBar'
import '../styles/navigation.scss';
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import StringHelper from '../utils/stringHelper'
import * as constants from '../constants/constants'
import * as bleedingRisk from '../models/BleedingRisk'

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.checkFlexBox();
    if (this.browserSupported) {
      this.reset();
    }
    // this.pushComponent(this.componentForQuestion(this.algorithm.raceQuestion));
    // this.pushComponent(<LearnMoreComponent />);
    // this.showLearnMore();
    // this.testRecommendation();
  }

  checkFlexBox() {
    var d = document.documentElement.style;
    this.browserSupported = true;
    if (!(('flexWrap' in d) || ('WebkitFlexWrap' in d) || ('msFlexWrap' in d))){
      this.browserSupported = false;
      // alert("Aspirin Guide is not optimized for this browser. Please use either Chrome, Firefox, Safari, or Microsoft Edge instead.");
    }
  }

  reset() {
    this.algorithm = new RecommendationAlgorithm();
    TextParser.emailStringFromText(RecommendationAlgorithm.appBackgroundText());
    this.state = {childComponents:[], showInfoButton: true, popping: false, showEULA: false, browserSupported: true};
    this.shownChildComponents = [];
    this.pushComponent(this.componentForQuestion(this.algorithm.introQuestion));
  }
  onBackButtonEvent(event) {
  event.preventDefault();
    this.popComponent();
}
  componentDidMount(){
  window.onpopstate = this.onBackButtonEvent.bind(this);
}
  componentDidUpdate(prevProps) {
    let children = this.state.childComponents;
    if (this.shownChildComponents.length > 0) {
      for (var component of this.shownChildComponents) {
        let isQuestion = component.props != null && component.props.question != null;
        if (isQuestion && children.indexOf(component) == -1) {
          component.props.question.selectedAnswer = null;
        }
      }
    }
    this.shownChildComponents = children.slice();
  }
  onNavBackButtonClick() {
    this.popComponent();
  }
  onNavInfoButtonClick() {
    this.showLearnMore();
  }
  onNavResetButtonClick() {
    this.confirmReset();
  }
  confirmReset() {
    if (confirm("Would you like to restart the algorithm?\nYour progress will be lost.") == true) {
      this.reset();
    }
  }
  onEULAAccepted() {
    this.setState({showEULA: false});
  }
  answeredQuestions() {
    return this.answered;
  }
  pushAnsweredQuestion(question) {
    let answered = this.answeredQuestions();
    if (answered == null) {
      answered = [question];
    }
    else {
      console.log(answered);
      answered.push(question);
    }
    this.answered= answered;
  }
  currentQuestion() {
    var currentQuestion = null;
    if (this.answeredQuestions() != null && this.answeredQuestions().length > 0) {
      let mostRecentQuestion = this.answeredQuestions()[this.answeredQuestions().length - 1];
      var answer = mostRecentQuestion.selectedAnswer;
      if (answer == null) {
        answer = mostRecentQuestion.inputAnswer;
      }
      if (answer.nextQuestion != null) {
        currentQuestion = answer.nextQuestion;
      }
      else if (answer.nextQuestionBlock != null) {
        currentQuestion = answer.nextQuestionBlock();
      }
    }
    return currentQuestion;
  }

  didSelectMultipleChoiceAnswer(questionComponent, answer) {
    let question = questionComponent.props.question;
    question.selectedAnswer = answer;
    if (answer.nextQuestion != null && answer.nextQuestion.isConfirmQuestion) {
      this.algorithm.updateConfirmAnswerForQuestions();
    }
      else if (question == this.algorithm.startQuestion && !Persistence.hasAcceptedEULA()) {
      this.setState({showEULA: true});
    }
    else if (answer.isLearnMore) {
      this.showLearnMore();
    }
    this.pushAnsweredQuestion(question);
    if (this.currentQuestion() == null) {
      this.showRecommendation();
    }
    else {
      this.showNextQuestion();
    }
  }
  didSelectedInputAnswer(questionComponent, inputAnswer, selectedValue) {
    inputAnswer.selectedValue = selectedValue;
    this.pushAnsweredQuestion(questionComponent.props.question);
    this.showNextQuestion();
  }

  showTextContent(text) {
    this.pushComponent(<TextComponent navigation={this} text={text}></TextComponent>);
  }

  showLearnMore() {
    this.pushComponent(<LearnMoreComponent navigation={this} showInfoButton={false}></LearnMoreComponent>);
  }

  showNextQuestion() {
    this.pushComponent(this.componentForQuestion(this.currentQuestion()))
  }

  showRecommendation() {
    console.log("show next rec");
    let recommendation = this.algorithm.recommendationForAnswers();
    if (recommendation != null) {
      this.pushComponent(this.componentForRecommendation(recommendation));
    }
  }

  updateHistory() {
    let children = this.state.childComponents;
    let childrenCount = children != null ? children.length : 0;
      let path = "/nav/" + childrenCount;
      this.props.history.push(path);

  }

  currentKey() {
    if (this.answeredQuestions() != null) {
      return this.answeredQuestions().length;
    }
    return 0;
  }

  popComponent() {
    this.setState({popping: true});
    let children = this.state.childComponents;
    if (children == null || children.length < 2) {
      return;
    }
    let component = children.pop();
    if (typeof component == "QuestionComponent") {
      let question = component.props.question;
    }
    this.setState({childComponents: children});
    this.updateNavBarButtons();
  }
  pushComponent(component) {
    this.setState({popping: false});
    console.log(component.type.displayName);
    let components = this.state.childComponents;
    components.push(component);
    this.setState({childComponents:components});
    this.updateHistory();
    this.updateNavBarButtons();
  }

  updateNavBarButtons() {
    let component = this.topComponent();
  if (component.type.displayName == "QuestionComponent") {
    this.setState({showInfoButton: true});
  }
  else if (component.type.displayName == "LearnMoreComponent") {
    this.setState({showInfoButton: false});
  }
}

  navBar() {
    return <NavBar showBackButton={this.state.childComponents.length > 1} showInfoButton={this.state.showInfoButton} delegate={this}/>;
  }

  componentForQuestion(question) {
    return <QuestionComponent key={this.currentKey()} question={question} delegate={this} navigation={this}></QuestionComponent>;
  }

  componentForRecommendation(recommendation) {
    return <RecommendationComponent key={this.currentKey()} recommendation={recommendation} delegate={this} navigation={this}></RecommendationComponent>;
  }

  topComponent() {
    let children = this.state.childComponents;
    if (children == null || children.length < 1) {
      return null;
    }
    return children[children.length-1];
  }

  testRecommendation() {
    let rec = RecommendationAlgorithm.recommendationForASCVDScore(16.12,
      1.11,
      constants.Gender.Male,
      70,
      [bleedingRisk.kBleedingRiskUlcer,
        bleedingRisk.kBleedingRiskComplicatedUlcer, bleedingRisk.kBleedingRiskNSAID], true, true, false);
    this.pushComponent(this.componentForRecommendation(rec));
  }

  renderTest() {
    return (
      <div className="root">
      </div>
    )
  }

  render() {
    if (!this.browserSupported) {
      return (<BrowserNotSupportedComponent />);
    }
    return (
      <div>
        <ReactCSSTransitionGroup transitionName={this.state.popping ? "pop" : "push"} transitionEnterTimeout={300} transitionLeaveTimeout={300}>
          {console.log(this.currentKey())}
          {this.topComponent()}
        </ReactCSSTransitionGroup>
        <ReactCSSTransitionGroup transitionName="fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
        {this.state.showEULA ? <DisclaimerComponent delegate={this}/> : null}
          </ReactCSSTransitionGroup>
        </div>
    )
  }
}

class NavQuestionDelegate extends QuestionComponentDelegate {
  didSelectMultipleChoiceAnswer(question, answer) {
  }
}

export default Navigation;



/** WEBPACK FOOTER **
 ** ./src/components/Navigation.js
 **/